import type { CapabilityObj } from 'homey-api';

import evcharger_charging from '../images/toggle/evcharger_charging.svg';
import garagedoor_closed from '../images/toggle/garagedoor_closed.svg';
import garagedoor_open from '../images/toggle/garagedoor_open.svg';
import windowcoverings_closed from '../images/toggle/windowcoverings_closed.png';
import windowcoverings_open from '../images/toggle/windowcoverings_open.png';

import { glyph } from '../../../theme/glyph';

export function getToggleImages(capabilityId: string, capabilityObj: CapabilityObj) {
  const [actualId] = capabilityId.split('.');

  const result = {
    urlTrue: '',
    urlFalse: '',
    useIconObj: false,
    iconObj: null as CapabilityObj['iconObj'],
    iconUrlTrue: '',
    iconUrlFalse: '',
  };

  switch (actualId) {
    case 'onoff':
      result.urlTrue = glyph.capability.onoff;
      result.urlFalse = glyph.capability.onoff;
      break;
    case 'locked':
      result.urlTrue = glyph.capability.locked;
      result.urlFalse = glyph.capability.unlocked;
      break;
    case 'windowcoverings_closed':
      result.urlTrue = windowcoverings_closed;
      result.urlFalse = windowcoverings_open;
      break;
    case 'garagedoor_closed':
      result.urlTrue = garagedoor_closed;
      result.urlFalse = garagedoor_open;
      break;
    case 'evcharger_charging':
      result.urlTrue = evcharger_charging;
      result.urlFalse = evcharger_charging;
      break;
    case 'volume_mute':
      result.urlTrue = glyph.capability.volumeSet;
      result.urlFalse = glyph.capability.volumeMuteCross;
      break;
    case 'speaker_shuffle':
      result.urlTrue = glyph.capability.speakerShuffle;
      result.urlFalse = glyph.capability.speakerShuffle;
      break;
    case 'speaker_playing':
      result.urlTrue = glyph.core.pause;
      result.urlFalse = glyph.core.play;
      break;
    case 'speaker_repeat':
      result.urlTrue = glyph.capability.speakerRepeatList;
      result.urlFalse = glyph.capability.speakerRepeat;
      break;
    default:
      if (capabilityObj.iconObj) {
        result.urlTrue = `https://icons-cdn.athom.com/${capabilityObj.iconObj.id}.svg`;
        result.urlFalse = `https://icons-cdn.athom.com/${capabilityObj.iconObj.id}.svg`;
        result.iconObj = capabilityObj.iconObj;
        result.useIconObj = true;
        break;
      }

      result.urlTrue = glyph.capability.onoff;
      result.urlFalse = glyph.capability.onoff;
  }

  result.iconUrlTrue = result.urlTrue;
  result.iconUrlFalse = result.urlFalse;

  return result;
}
